import {Component, computed, inject, signal} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {TranslocoPipe} from "@jsverse/transloco";
import {AuthenticationService} from "@services";

@Component({
  selector: 'wun-profile',
  imports: [
    RouterOutlet,
    TranslocoPipe,
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {

  private authenticationService = inject(AuthenticationService);

  items = this.authenticationService.items;

}
